/**
 * Raw pricing-credit ledger units per one display recruitment credit.
 * Shared by core-api, web, and other consumers — keep in sync with pricing ledgers.
 */
export enum PricingCreditRawUnits {
  B2CCredits = 30,
  B2BCredits = 50,
}

/** Minimum prepayment as a fraction of estimated totals (20%). */
export const PRICING_MINIMUM_DEPOSIT_PERCENTAGE = 0.2 as const;
